import { render } from "./drugManagement.vue?vue&type=template&id=13fe2a48&scoped=true"
import script from "./drugManagement.vue?vue&type=script&lang=js"
export * from "./drugManagement.vue?vue&type=script&lang=js"

import "./drugManagement.vue?vue&type=style&index=0&id=13fe2a48&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13fe2a48"]])

export default __exports__